import { render } from "./pb-formtutors.vue?vue&type=template&id=6184433c"
import script from "./pb-formtutors.vue?vue&type=script&lang=js"
export * from "./pb-formtutors.vue?vue&type=script&lang=js"

import "./pb-formtutors.vue?vue&type=style&index=0&id=6184433c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__